import { Box, styled } from "@mui/system";
import Toolbar from "@mui/material/Toolbar";
import { FaCircleUser } from "react-icons/fa6";
import { Link } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Typography } from "@mui/material";

import { colors } from "../../styles/colors";
import fontWeight from "../../styles/mui/fontWeight";

export const HeaderToolbar = styled(Toolbar)((props) => ({
  minHeight: "4.5rem",
  display: "flex",
  justifyContent: "space-between",
  [props.theme.breakpoints.up("sm")]: {
    minHeight: "4.5rem",
  },
  boxShadow: "0rem 0.25rem 0.625rem rgba(0, 0, 0, 0.2)",
}));

export const HeaderArrowDropDownIcon = styled(ArrowDropDownIcon)(() => ({
  fontSize: "1.85rem",
  color: colors.fonts[26],
  marginLeft: "0.15rem",
}));

export const FaCircleUserIcon = styled(FaCircleUser as React.ComponentType)(() => ({
  marginLeft: "-0.35rem",
  marginRight: "0.35rem",
  color: colors.black[1],
  fontSize: "2.35rem",
}));

export const UserDetails = styled(Box)(() => ({
  display: "flex",
  color: colors.black[1],
  fontSize: "2rem",
  flexDirection: "column",
  padding: "0.15rem 0.25rem",
  minWidth: 0,
  width: "auto",
}));

export const UserDetailsText = styled(Typography)(() => ({
  color: colors.black[1],
  variant: "h2",
}));

export const UserDetailsTextStyle = (type: number) => ({
  fontSize: type === 1 ? "1rem" : "0.72rem",
  fontWeight: fontWeight.Weight[6],
  display: "block",
  lineHeight: 1.15,
  paddingTop: type === 1 ? "0" : "0.1rem",
  paddingBottom: type === 1 ? "0.12rem" : "0",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%",
  color: colors.black[1],
  textTransform: type === 1 ? "capitalize" : "none",
});

export const LogoLink = styled(Link)(() => ({
  display: "flex",
  alignItems: "center",
}));

export const LogoImg = styled("img")(() => ({
  width: "auto",
  paddingLeft: "1.5rem",
  height: "1.7rem",
}));

export const HeaderContainer = () => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignItems: "center",
  padding: "0.8rem 1.4rem",
});

export const UserMenuPaperStyle = {
  minWidth: "11rem",
  borderRadius: "0.25rem",
};

export const UserMenuItemStyle = {
  fontSize: "0.75rem",
  color: colors.black[1],
  paddingTop: "0.5rem",
  paddingBottom: "0.5rem",
  justifyContent: "center",
  textAlign: "center",
};

export const HeaderPaperStyle = {
  position: "fixed",
  zIndex: 5,
  width: "100%",
};

export const ButtonVerifyStyle = {
  borderRadius: "0.3125rem",
  backgroundColor: colors.primary.main,
};

export const HorizontalDivider = () => ({
  color: colors.dropShadow[4],
  margin: "0.72rem 0 0.72rem 0",
});

export const ModalBox = () => ({
  position: "relative",
  width: "33%",
  backgroundColor: "background.paper",
  padding: "1rem",
});

export const ModalGrid = () => ({
  marginTop: "0.9rem",
  marginBottom: "2.1rem",
});
